import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    FormInputComponent,
    InputComponentConfig,
    SharedModule,
} from '@vendure/admin-ui/core';

@Component({
    standalone: true,
    selector: 'max-value-input',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, SharedModule],
    template: `
        <vdr-form-field for="maxValue">
            <vdr-currency-input
                [formControl]="formControl"
                [currencyCode]="currencyCode"
                name="maxValue"
            ></vdr-currency-input>
        </vdr-form-field>
    `,
    styles: [
        `
            vdr-form-field {
                width: 50%;
            }
        `,
    ],
})
export class MaxValueInputComponent
    implements FormInputComponent<InputComponentConfig>
{
    @Input() readonly = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;

    currencyCode = 'BRL';
}
